import http from 'hub-http/clients/apiClient';
import { LIST_EXPORT_TYPES } from '../../../types/exportTypes';
import { getJourneyQuery } from 'reporting-data/report/reportGetters';
const BASE_URL = 'journey-analytics/v1/object-list';
const createNewList = (query, listName) => {
  return http.post(BASE_URL, {
    data: {
      objectListName: listName,
      journeyQuery: query
    }
  });
};
const addToExistingList = (query, listId) => {
  return http.put(`${BASE_URL}/${listId}`, {
    data: {
      journeyQuery: query
    }
  });
};
export const journeysExportToList = (type, report, listNameOrId) => {
  const journeyQuery = getJourneyQuery(report);
  const query = journeyQuery && journeyQuery.toJS();
  if (type === LIST_EXPORT_TYPES.NEW) {
    return createNewList(query, listNameOrId);
  } else {
    return addToExistingList(query, listNameOrId);
  }
};